import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, FreeMode, EffectFade } from 'swiper';
import { $qs, $qsa } from './utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);



function teamSlider() {

  const slider = $qsa("[data-name='team-slider']");

  if (!slider.length) return;
  
  const homeTeam = $qsa('[data-name="home-team"]');
  const homeTeamTitle = $qs('[data-name="home-team-title"]');
  const homeTeamIntro = $qs('[data-name="home-team-intro"]');
  const homeTeamSliderSlides = $qsa('[data-name="team-slider"] .swiper-slide');
//   convert to an array in order to rearrange
  var slidesArray = Array.prototype.slice.call(homeTeamSliderSlides)
  slidesArray.unshift(slidesArray.pop());
  console.log(slidesArray);

  const homeTeamTitleSplit = new SplitText(homeTeamTitle, {type: "chars, words", wordsClass: "word", charsClass: "char"});

  const timeline = gsap.timeline();

  timeline
  .from(homeTeamTitleSplit.chars, {opacity: 0, y: '20px', stagger: '0.01'})
  .from(homeTeamIntro, {opacity: 0 })
  .from(slidesArray, {opacity: 0, stagger: 0.4, duration: 1, ease: "power4.out"})

      ScrollTrigger.create({
          trigger: homeTeam,
          start: 'top 70%',
          animation: timeline,
          markers: false
      })



var swiper = new Swiper("[data-name='team-slider']", {
    modules: [Navigation, Scrollbar, Autoplay, FreeMode, Pagination],
    loop: true,
    slidesPerView: 'auto',
    loopedSlides: 4,
    centeredSlides: true,
    loop: true,
    // autoplay: {
    //     delay: 5000,
    //     disableOnInteraction: true
    // },
    navigation: {
        nextEl: '.team-swiper-button-next',
        prevEl: '.team-swiper-button-prev',
      },
 
     });

    //  swiper.on('slideChange', function () {
    //   console.log('slide changed');
    //   console.info(this.activeIndex);
    //   [...controls].forEach((control) => {
    //     if(this.activeIndex == control.dataset.value){
    //       control.classList.add('opacity-100')
    //       control.classList.remove('opacity-20')
    //     }else{
    //       control.classList.add('opacity-20')
    //       control.classList.remove('opacity-100')
    //     }
      
  
    //    })
    // });

    //  [...controls].forEach((control) => {
    //   control.addEventListener('click', () => {
    //     console.info('click test:' );
    //   swiper.slideTo(control.dataset.value, '600',);
    //   })
    //   control.addEventListener('mouseover', () => {
    //     gsap.to(animatedCircle,{x:0, y: 0})

    //   })

    //  })



}

    export default teamSlider;